module.exports = __webpack_public_path__ + "static/img/logo.a6b0570.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo.png
// module id = KItN
// module chunks = 40